// Benannte Masse und Farben des Rahmens (ST-UX-001, G2a; v4 `:root`).
//
// Der Kopf der Anwendung hat EIGENE Farben statt der Marken-Token des Themes:
// `colorBrandBackground` ist die Flaeche jeder Hauptaktion, und sie wird im
// Dunkeln das helle Dark-Mode-Blau des Handbuchs (theme.ts). Auf diesem Blau
// stuende weisse Schrift nicht mehr; der Kopf braucht sein dunkles Blau
// deshalb unabhaengig vom Knopf. Weiss darauf: 6,00:1 (hell) und 11,63:1
// (dunkel, v4 `head-bg` #1B3A5C) in Ruhe, 7,45 / 6,00 bei Hover, 12,94 gedrueckt.

export const KOPF_FLAECHE = { hell: '#2164ae', dunkel: '#1b3a5c' } as const;
export const KOPF_FLAECHE_HOVER = { hell: '#1b5696', dunkel: '#2164ae' } as const;
export const KOPF_FLAECHE_GEDRUECKT = { hell: '#0c325b', dunkel: '#0c325b' } as const;
export const KOPF_SCHRIFT = { hell: '#ffffff', dunkel: '#ffffff' } as const;

/** v4 `.top` im MVP-Entwurf: 60 px, in rem, damit der Kopf mit dem Textzoom waechst. */
export const KOPF_HOEHE = '3.75rem';

/**
 * Der Suchausloeser und das Konto auf dem Blau (v4 `.top .searchbtn`, `.top .avatar`).
 *
 * Die Flaeche ist 12 % Weiss: Weiss darauf haelt 4,64:1 auf dem hellen und
 * 8,08:1 auf dem dunklen Kopf. Der Rand ist 60 % Weiss statt v4 45 %: erst
 * damit grenzt er sich mit 3,23:1 vom hellen Kopf ab (WCAG 1.4.11); 45 %
 * ergaeben 2,48:1.
 */
export const KOPF_SUCHE = {
  flaeche: 'rgba(255, 255, 255, 0.12)',
  rand: 'rgba(255, 255, 255, 0.6)',
} as const;

/**
 * "Kontakt anlegen" und das Konto-Bildzeichen: weiss mit dunkler Schrift in
 * BEIDEN Schemata (v4 `.top .btn.primary`, `.top .avatar`). Es sind Kopfknoepfe,
 * keine Theme-Knoepfe; im Dunkeln wuerde die Theme-Flaeche im Nachtblau versinken.
 * Tinte auf Weiss 17,6:1, auf der Hover-Flaeche (v4 `brand-soft`) 15,6:1.
 */
export const KOPF_KNOPF = { flaeche: '#ffffff', hover: '#e6f0fa', schrift: '#16191f' } as const;

/** v4 `.app`-Spalte und `.nav a` (240 px, Zeile 36 px). */
export const NAV_BREITE = '15rem';
export const NAV_ZEILE = '2.25rem';

/** Die Variablen, die `layout.tsx` am Kopf setzt; Kinder lesen sie. */
export const KOPF_VAR = {
  flaeche: 'var(--liaison-kopf-flaeche)',
  hover: 'var(--liaison-kopf-hover)',
  gedrueckt: 'var(--liaison-kopf-gedrueckt)',
  schrift: 'var(--liaison-kopf-schrift)',
} as const;

/** v4 `fs-h1`: der Name in der Kopfkarte. */
export const UEBERSCHRIFT_KOPF = '1.375rem';
/** v4 `fs-h2` und `gap`: Abschnittsueberschriften der Kontaktkarten. */
export const ABSCHNITT_SCHRIFT = '0.9375rem'; // 15 px, folgt der Basisgroesse
export const ABSCHNITT_ABSTAND = '1rem';
